import { FC, useEffect, useState } from 'react';
import LottieWrapper from './LottieWrapper';
import { ENV_CONFIG } from 'config/environment';
import { defaultOptions } from './commonOptions';
import * as animationVerticalLine1 from 'assets/json/vertical_line1.json';
import * as animationVerticalLine2 from 'assets/json/vertical_line2.json';
import * as animationVerticalLine3 from 'assets/json/vertical_line3.json';
import * as animationVerticalLine4 from 'assets/json/vertical_line4.json';
import * as animationHorizontalLine1 from 'assets/json/horizontal_line1.json';
import * as animationHorizontalLine2 from 'assets/json/horizontal_line2.json';
import * as animationHorizontalLine3 from 'assets/json/horizontal_line3.json';
import * as animationHorizontalLine4 from 'assets/json/horizontal_line4.json';
import { BREAKPOINTS } from 'constants/breakpoints';

const VERTICAL_FALLBACK_ANIMATIONS = {
  1: animationVerticalLine1,
  2: animationVerticalLine2,
  3: animationVerticalLine3,
  4: animationVerticalLine4,
} as const;

const HORIZONTAL_FALLBACK_ANIMATIONS = {
  1: animationHorizontalLine1,
  2: animationHorizontalLine2,
  3: animationHorizontalLine3,
  4: animationHorizontalLine4,
} as const;

interface Props {
  number: number;
}

const OurImpactLine: FC<Props> = ({ number }) => {
  const [fetchedAnimation, setFetchedAnimation] = useState<any>(null);
  const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth <= BREAKPOINTS.DESKTOP);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= BREAKPOINTS.DESKTOP);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    // Fetch the JSON file from the URL
    const fetchAnimationData = async () => {
      try {
        const response = await fetch(
          `${ENV_CONFIG().CLOUD_STORAGE.URL}/json/static_pages/vertical_line${number}.json`
        );
        const jsonData = await response.json();
        setFetchedAnimation(jsonData);
      } catch {
        setFetchedAnimation(null);
      }
    };

    fetchAnimationData();
  }, [number]);

  const animationData =
    fetchedAnimation ||
    (isMobile
      ? HORIZONTAL_FALLBACK_ANIMATIONS[number as keyof typeof HORIZONTAL_FALLBACK_ANIMATIONS]
      : VERTICAL_FALLBACK_ANIMATIONS[number as keyof typeof VERTICAL_FALLBACK_ANIMATIONS]);

  return (
    <div className="orbs-line-wrapper">
      {!isMobile && <div className="orbs-blurred-background" />}
      {animationData && (
        <LottieWrapper options={defaultOptions(animationData)} isClickToPauseDisabled={true} />
      )}
    </div>
  );
};

export default OurImpactLine;
